import React, { useCallback, useState } from 'react';
import { VStack } from 'native-base';
import { useEffectOnce } from 'usehooks-ts';
import {
    useSpringBigStore,
    useDeleteAccount,
    loginByPhoneNumber,
    useAppSettings,
} from '@springbig/shared';
import PinForm, { PinFormData } from '~/pages/auth/components/PinForm';
import { Caption } from '~/shared/Typography';
import { useAppNavigate } from '..';
import { Button, Section } from '~/shared/Theme';

const DeleteAccountScreen = () => {

    const [codeId, setCodeId] =
        useState<number>();

    const {
        mutate: deleteAccount,
        isLoading
    } = useDeleteAccount();

    const { phoneNumber, member } = useSpringBigStore();
    const { merchantOrg } = useAppSettings();
    const { navigate, params } = useAppNavigate();

    const getAccesCodeId = useCallback(async () => {

        const code = await loginByPhoneNumber({
            native_app_name: merchantOrg,
            phone_number: phoneNumber!
        });

        if (code) {
            setCodeId(parseInt(code.member_access_code_id));
        }

    }, [merchantOrg, phoneNumber]);

    useEffectOnce(() => {

        getAccesCodeId();
    });

    const handleSubmit = (values: PinFormData) => {

        deleteAccount({
            code_id: codeId || 123,
            code_value: values.pin,
            member: {
                merchant_id: member?.merchant_id,
                phone_number: phoneNumber!
            }
        });
    };

    return (
        <Section p={4} justifyContent={'center'}>
            <VStack space={8}>
                <Caption
                    text={'accountInformation.delete_account_header_title'}
                />
                <VStack space={4}>
                    <PinForm
                        buttonType={'danger'}
                        buttonText={'Delete'}
                        size={4}
                        isLoading={isLoading}
                        handleSubmitValues={handleSubmit}
                    />
                    <Button
                        text={'general.cancel'}
                        variant={'neutral'}
                        disabled={isLoading}
                        onPress={() => navigate(`w/${params.wallet_id}/profile`)}
                    />
                </VStack>
            </VStack>
        </Section>
    );
};

export default DeleteAccountScreen;
